module.exports = __webpack_public_path__ + "static/toolPanel-5e3633b71749b7dcaf63d8229ae58121.gif";